import type { ImpactByMonth, Initiative, MonthlyImpactMap } from "aint-types";
import { NUMBER_TO_MONTH } from "aint-utils";
import dayjs from "dayjs";

/**
 * Checks if any field of the given impact array has an empty or undefined value
 */
export function getMissingImpactValues(
  impactValues: MonthlyImpactMap | undefined,
  formFields: Partial<Initiative>
) {
  const missingFields: { year: string; month: number }[] = [];

  const { startDate, monitoringEndDate } = formFields ?? {};

  if (!startDate || !monitoringEndDate) {
    return missingFields;
  }

  const start = dayjs(startDate);
  const end = dayjs(monitoringEndDate);

  if (end.isBefore(start)) {
    return missingFields;
  }

  const startMonth = start.month();
  const startYear = start.year();
  const endMonth = end.month();
  const endYear = end.year();

  let month = startMonth;
  let year = startYear;

  while (year <= endYear && month <= endMonth) {
    const impactValue =
      impactValues?.[String(year)]?.[
        NUMBER_TO_MONTH[month] as keyof ImpactByMonth
      ];
    if (impactValue === undefined || impactValue === "") {
      missingFields.push({ year: year.toString(), month });
    }

    month++;

    if (month > 11) {
      month = 0;
      year++;
    }
  }

  return missingFields;
}
